import { createAction, handleActions } from 'redux-actions';

import { List, Map, fromJS } from 'immutable';
import { pender } from 'redux-pender';

import * as common from 'libs/commonFunc';
import * as targetLib from 'libs/targetLib';
import * as eduLib from 'libs/eduLib';
import * as normalizer from 'libs/normalizer';
import * as normal from 'libs/normalizer';

// action types
const INITIAL_STORE = 'target/INITIAL_STORE';
const CHANGE_TARGET = 'target/CHANGE_TARGET';
const CHANGE_TARGET_PARAM = 'currentStatus/CHANGE_TARGET_PARAM';
const CHANGE_TARGET_EXAM = 'currentStatus/CHANGE_TARGET_EXAM';
const GET_TARGET = 'target/GET_TARGET';
const POST_TARGET = 'target/POST_TARGET';
const PUT_TARGET = 'target/PUT_TARGET';
const DELETE_TARGET = 'target/DELETE_TARGET';
const TOGGLE_ADD_TARGET = 'target/TOGGLE_ADD_TARGET';
const TOGGLE_EDIT_TARGET = 'target/TOGGLE_EDIT_TARGET';
// targetTag
const PUT_TAG_TARGET = 'target/PUT_TAG_TARGET';
const POST_TAG_TARGET = 'target/POST_TAG_TARGET';
const DELETE_TAG_TARGET = 'target/DELETE_TAG_TARGET';
// [대상자 상세] 훈련 이력
const GET_TARGET_EXAMLIST = 'target/GET_TARGET_EXAMLIST';
// [대상자 상세] 선택 대상자들의 훈련 이력
const GET_TARGET_MERGEDETAIL = 'target/GET_TARGET_MERGEDETAIL';
// [대상자 상세] 교육 이력
const GET_EDU_HISTORY = 'target/GET_EDU_HISTORY';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeTarget = createAction(CHANGE_TARGET);
export const changeTargetParam = createAction(CHANGE_TARGET_PARAM);
export const changeTargetExam = createAction(CHANGE_TARGET_EXAM);
export const getTarget = createAction(GET_TARGET, targetLib.getTargetAPI);
export const postTarget = createAction(POST_TARGET, targetLib.postTargetAPI);
export const putTarget = createAction(PUT_TARGET, targetLib.putTargetAPI);
export const deleteTarget = createAction(DELETE_TARGET, targetLib.deleteTargetAPI);
export const toggleAddTarget = createAction(TOGGLE_ADD_TARGET);
export const toggleEditTarget = createAction(TOGGLE_EDIT_TARGET);
// targetTag
export const putTagTarget = createAction(PUT_TAG_TARGET, targetLib.putTagTargetAPI);
export const postTagTarget = createAction(POST_TAG_TARGET, targetLib.postTagTargetAPI);
export const deleteTagTarget = createAction(DELETE_TAG_TARGET, targetLib.deleteTagTargetAPI);
// [대상자 상세] 훈련이력
export const getTargetExamList = createAction(GET_TARGET_EXAMLIST, targetLib.getTargetExamListAPI);
// [대상자 상세] 선택 대상자들의 훈련 이력
export const getMergeDetail = createAction(GET_TARGET_MERGEDETAIL, targetLib.getMergeDetailAPI);
// [대상자 상세] 교육 이력
export const getEduHistory = createAction(GET_EDU_HISTORY, eduLib.getEduHistoryAPI);

// initial state
const initialState = Map({
  // 새로고침
  needReload: false,
  page: 1,
  totalPages: 0,
  totalTarget: 0,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'targetNo', order: 'DESC' }],
    offset: 0,
    limit: 30
  }),
  // 필터 리스트
  filter: Map({}),
  targetOrdering: List([]),
  targetDataByTargetNo: Map({}),
  // 현재 선택한 대상자
  curTarget: Map({}),
  // [대상자 상세] 훈련 이력
  targetExam: Map({
    isOpen: List([]),
    needReload: false,
    data: List([]),
    param: Map({
      filter: {},
      sort: [{ field: 'targetNo', order: 'DESC' }],
      offset: 0,
      limit: 5
    }),
    page: 1,
    totalPages: 0,
    totalExam: 0,
    chartData: {}
  }),
  // [대상자 상세] 다중 선택시 대상자 정보
  mergeDetail: Map({
    target: 0,
    send: 0,
    read: 0,
    download: 0,
    infection: 0,
    infectionPc: 0
  }),
  // [결과보기 상세] 교육 이력
  eduList: Map({
    needReload: false,
    data: List([]),
    param: Map({
      filter: {},
      sort: [{ field: 'eduNo', order: 'DESC' }],
      offset: 0,
      limit: 5
    }),
    page: 1,
    totalPages: 0,
    totalEdu: 0
  })
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_TARGET]: (state, action) => {
      const { name, value } = action.payload;

      return state.set(name, value);
    },
    [CHANGE_TARGET_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    [CHANGE_TARGET_EXAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['targetExam', name], value);
    },

    // 대상 조회
    ...pender({
      type: GET_TARGET,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }
        const { list, filter } = action.payload.data;
        const { refresh, offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = list.length > 0 ? list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);

        state = state.set('needReload', false);

        state = state.set('filter', fromJS(filter));
        let curPage = 1;
        let curArray = [];
        let curData = {};
        if (list.length > 0) {
          if (refresh) {
            state = state.set('totalPages', totalPages).set('totalTarget', totalCount);
            curArray = normalizer.targetArrayNormalize(list);
            curData = normalizer.targetNormalize(list);
          } else {
            curPage = state.get('page') + 1;
            curArray = state
              .get('targetOrdering')
              .toJS()
              .concat(normalizer.targetArrayNormalize(list));
            curData = Object.assign(state.get('targetDataByTargetNo').toJS(), normalizer.targetNormalize(list));
          }
        } else {
          state = state.set('totalPages', 0).set('totalTarget', 0);
        }
        return state
          .set('page', curPage)
          .set('targetOrdering', fromJS(curArray))
          .set('targetDataByTargetNo', fromJS(curData));
      },
      onFailure: (state, action) => {
        return state
          .set('targetOrdering', initialState.get('targetOrdering'))
          .set('targetDataByTargetNo', initialState.get('targetDataByTargetNo'));
      }
    }),

    // 대상 추가
    ...pender({
      type: POST_TARGET,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const tagNoArray = JSON.parse(action.payload.config.data).tagNoArray;

        let targetNo = 0;
        if (list) {
          targetNo = Number(list[0].targetNo);

          if (!!tagNoArray) {
            list[0]['tagList'] = JSON.parse(tagNoArray);
          } else {
            list[0]['tagList'] = null;
          }

          return state
            .set('targetOrdering', state.get('targetOrdering').splice(0, 0, targetNo))
            .mergeIn(['targetDataByTargetNo'], fromJS(normalizer.targetNormalize(list)));
        } else {
          return state.set('needReload', true);
        }
      },
      onFailure: (state, action) => {
        //
      }
    }),
    // 대상 수정
    ...pender({
      type: PUT_TARGET,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const params = JSON.parse(action.payload.config.data);

        // 수정한 타입
        const changeType = [];
        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            if (key !== 'targetNo') {
              changeType.push(key);
            }
          }
        }

        let tiDataByTargetNo = state.get('targetDataByTargetNo');
        for (let i = 0, l = changeType.length; i < l; i++) {
          tiDataByTargetNo = tiDataByTargetNo.update(String(list[0].targetNo), target =>
            target.set(changeType[i], list[0][changeType[i]])
          );
        }
        tiDataByTargetNo = tiDataByTargetNo.update(String(list[0].targetNo), target =>
          target.set('modifyEpoch', list[0]['modifyEpoch'])
        );

        return state.set('targetDataByTargetNo', tiDataByTargetNo).set('needReload', true);
      },
      onFailure: (state, action) => {
        //
      }
    }),
    // 대상 삭제
    ...pender({
      type: DELETE_TARGET,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        let prevData = state.get('targetOrdering');
        const prevDataByTargetNo = state.get('targetDataByTargetNo').toJS();
        let indexArray = [];
        for (let i = 0, l = list.length; i < l; i++) {
          const indexArray = prevData.findIndex(targetNo => targetNo === list[i].targetNo);
          prevData = prevData.splice(indexArray, 1);

          delete prevDataByTargetNo[list[i].targetNo];
        }
        indexArray = common.ArraySort(indexArray, 'desc');
        return state.set('targetOrdering', fromJS(prevData)).set('targetDataByTargetNo', fromJS(prevDataByTargetNo));
      },
      onFailure: (state, action) => {
        //
      }
    }),
    // 대상 태그 수정
    ...pender({
      type: PUT_TAG_TARGET,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const targetNo = JSON.parse(action.payload.config.data).targetNo;
        const tagNoArray = JSON.parse(action.payload.config.data).tagNoArray;

        const dataByTargetNo = state.get('targetDataByTargetNo').toJS();

        dataByTargetNo[targetNo]['tagList'] = list;

        return state.set('targetDataByTargetNo', fromJS(dataByTargetNo));
      }
    }),
    // 대상 태그 일괄 추가
    ...pender({
      type: POST_TAG_TARGET,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const isAllCheck = Number(JSON.parse(action.payload.config.data).isAllCheck);
        let tagNoArray = JSON.parse(action.payload.config.data).tagNoArray;
        let targetNoArray = JSON.parse(action.payload.config.data).targetNoArray;
        tagNoArray = JSON.parse(tagNoArray);

        if (isAllCheck === 1) {
          state.get('targetDataByTargetNo').map((targetInfo, targetNo) => {
            const tagListTDBTN = !!state.getIn(['targetDataByTargetNo', targetNo, 'tagList'])
              ? state.getIn(['targetDataByTargetNo', targetNo, 'tagList']).toJS()
              : [];

            state = state.setIn(
              ['targetDataByTargetNo', targetNo, 'tagList'],
              fromJS(common.ArrayDuplicateRemove(tagListTDBTN.concat(tagNoArray)))
            );
          });
        } else {
          targetNoArray = JSON.parse(targetNoArray);

          for (let i = 0, l = targetNoArray.length; i < l; i++) {
            const targetNo = String(targetNoArray[i]);
            const tagListTDBTN = !!state.getIn(['targetDataByTargetNo', targetNo, 'tagList'])
              ? state.getIn(['targetDataByTargetNo', targetNo, 'tagList']).toJS()
              : [];

            state = state.setIn(
              ['targetDataByTargetNo', targetNo, 'tagList'],
              fromJS(common.ArrayDuplicateRemove(tagListTDBTN.concat(tagNoArray)))
            );
          }
        }

        return state;
      }
    }),
    // 대상 태그 일괄 삭제
    ...pender({
      type: DELETE_TAG_TARGET,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { isAllCheck } = action.payload.config.params;
        let { targetNoArray, tagNoArray } = action.payload.config.params;
        tagNoArray = JSON.parse(tagNoArray);

        if (Number(isAllCheck) === 1) {
          state.get('targetDataByTargetNo').map((targetInfo, targetNo) => {
            for (let j = 0, m = tagNoArray.length; j < m; j++) {
              const tagNo = tagNoArray[j];
              const indexTDBTN = state
                .getIn(['targetDataByTargetNo', targetNo, 'tagList'])
                .findIndex(tag => tag === Number(tagNo));

              if (indexTDBTN !== -1) {
                state = state.deleteIn(['targetDataByTargetNo', targetNo, 'tagList', indexTDBTN]);
              }
            }
          });
        } else {
          targetNoArray = JSON.parse(targetNoArray);

          for (let i = 0, l = targetNoArray.length; i < l; i++) {
            const targetNo = String(targetNoArray[i]);

            for (let j = 0, m = tagNoArray.length; j < m; j++) {
              const tagNo = tagNoArray[j];
              const indexTDBTN = state
                .getIn(['targetDataByTargetNo', targetNo, 'tagList'])
                .findIndex(tag => tag === Number(tagNo));

              if (indexTDBTN !== -1) {
                state = state.deleteIn(['targetDataByTargetNo', targetNo, 'tagList', indexTDBTN]);
              }
            }
          }
        }

        return state;
      },
      onFailure: (state, action) => {
        //
      }
    }),
    // 대상 상세 - 훈련조회
    ...pender({
      type: GET_TARGET_EXAMLIST,
      onSuccess: (state, action) => {
        const { list, totalData } = action.payload.data;
        const { refresh, offset, limit } = action.payload.config.params;

        state = state.setIn(['targetExam', 'needReload'], false);

        let curPage = 1;
        let curArray = [];
        if (list.length > 0) {
          if (refresh) {
            state = state
              .setIn(['targetExam', 'totalPages'], Math.ceil(list[0].rnum / limit))
              .setIn(['targetExam', 'totalExam'], list[0].rnum);

            curArray = list;
          } else {
            curPage = state.getIn(['targetExam', 'page']) + 1;
            curArray = state
              .getIn(['targetExam', 'data'])
              .toJS()
              .concat(list);
          }
        } else {
          state = state.setIn(['targetExam', 'totalPages'], 0).setIn(['targetExam', 'totalExam'], 0);
        }

        return state
          .setIn(['targetExam', 'chartData'], totalData[0])
          .setIn(['targetExam', 'page'], curPage)
          .setIn(['targetExam', 'isOpen'], List([]))
          .setIn(['targetExam', 'data'], fromJS(curArray));
      },
      onFailure: (state, action) => {
        return state.setIn(['targetExam', 'data'], List([]));
      }
    }),
    // 대상 상세 - 다중 선택된 대상자 정보
    ...pender({
      type: GET_TARGET_MERGEDETAIL,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        return state.set('mergeDetail', list[0]);
      },
      onFailure: (state, action) => {
        return state.set('mergeDetail', Map({}));
      }
    }),
    // 훈련별 교육 이력
    ...pender({
      type: GET_EDU_HISTORY,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const { refresh, which, offset, limit } = action.payload.config.params;

        state = state.setIn(['eduList', 'needReload'], false);

        let curPage = 1;
        let curArray = [];
        if (list.length > 0) {
          if (refresh) {
            state = state
              .setIn(['eduList', 'totalPages'], Math.ceil(list[0].rnum / limit))
              .setIn(['eduList', 'totalEdu'], list[0].rnum);

            curArray = list;
          } else {
            curPage = state.getIn(['eduList', 'page']) + 1;
            curArray = state
              .getIn(['eduList', 'data'])
              .toJS()
              .concat(list);
          }
        } else {
          state = state.setIn(['eduList', 'totalPages'], 0).setIn(['eduList', 'totalEdu'], 0);
        }

        return state.setIn(['eduList', 'page'], curPage).setIn(['eduList', 'data'], fromJS(curArray));
      },
      onFailure: (state, action) => {
        return state.setIn(['eduList', 'data'], List([]));
      }
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/target.js